module.exports = __webpack_public_path__ + "img/section_t.e704a0eb.png";